const sortExamList = (
  examList,
  sortOrder,
  isCaseListAscending,
  reviewLaterExams
) => {
  let newExamList = examList;

  switch (sortOrder) {
    case "CaseNumber":
      newExamList = [...newExamList].sort((a, b) => {
        return a.examNumber - b.examNumber;
      });
      break;
    case "CompletionDate":
      newExamList = [...newExamList].sort((a, b) => {
        if (a.Completed) {
          return (
            new Date(b.MostRecentCompletionDate) -
            new Date(a.MostRecentCompletionDate)
          );
        } else {
          return false;
        }
      });
      break;
    case "ReviewLater":
      newExamList = [...newExamList].sort((a, b) => {
        return (
          (reviewLaterExams[b.ExamId] || 0) - (reviewLaterExams[a.ExamId] || 0)
        );
      });
      break;
    case "AverageGrade":
      newExamList = [...newExamList].sort((a, b) => {
        return b.MostRecentCompletionScore - a.MostRecentCompletionScore;
      });
      break;
    case "CaseTitle":
      newExamList = [...newExamList].sort((a, b) => {
        return a.examTitle === b.examTitle
          ? 0
          : a.examTitle < b.examTitle
          ? -1
          : 1;
      });
      break;
    default:
      break;
  }

  if (!isCaseListAscending) {
    newExamList = [...newExamList].reverse();
  }

  return newExamList;
};

export default sortExamList;
